export class ScheduleHour {
  hour:number
  monday:number
  tuesday:number
  wednesday:number
  thursday:number
  friday:number
  saturday:number
  sunday:number

  constructor (hour:number, monday:number, tuesday:number, wednesday:number, thursday:number, friday:number, saturday:number, sunday:number) {
    this.hour = hour
    this.monday = monday
    this.tuesday = tuesday
    this.wednesday = wednesday
    this.thursday = thursday
    this.friday = friday
    this.saturday = saturday
    this.sunday = sunday
  }

  getIndexForDay (dayName:string):number {
    let index = 1
    switch (dayName.toLowerCase()) {
      case 'monday':
        index = this.monday
        break
      case 'tuesday':
        index = this.tuesday
        break
      case 'wednesday':
        index = this.wednesday
        break
      case 'thursday':
        index = this.thursday
        break
      case 'friday':
        index = this.friday
        break
      case 'saturday':
        index = this.saturday
        break
      case 'sunday':
        index = this.sunday
        break
      default:
        index = -1
        break
    }
    return index
  }
}
